export default "__VITE_ASSET__CMIBqXwN__"